import { Outlet } from 'react-router-dom';
import { useBookitupMailFolderCounts } from '../hooks/useBookitupMailFolderCounts';
import { PostboxCountersContext } from './PostboxCountersContext';

// eslint-disable-next-line import/prefer-default-export
export const GeneralPostboxCountsProvider = () => {
  const value = useBookitupMailFolderCounts();
  return (
    <PostboxCountersContext.Provider value={value}>
      <Outlet />
    </PostboxCountersContext.Provider>
  );
};
